import React, { useState, useContext, useEffect } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import AllUsersTable from "./AllUsersTable";
import PropertyAccountsTable from "./PropertyAccountsTable";
import { PermissionsContext } from "../../utils/PermissionsContext";

const UsersPage = () => {
  const permissionsCtx = useContext(PermissionsContext);
  const hasPermission =
    typeof permissionsCtx === "function"
      ? permissionsCtx
      : (perm) => Array.isArray(permissionsCtx) && permissionsCtx.includes(perm);

  const tabConfig = [
    { label: "Users", component: <AllUsersTable />, permission: "view_users_accounts" },
    { label: "Members Accounts", component: <PropertyAccountsTable />, permission: "view_member_accounts" },
  ];

  const visibleTabs = tabConfig.filter(
    ({ permission }) => !permission || hasPermission(permission)
  );

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_event, newValue) => setTabIndex(newValue);

  useEffect(() => {
    if (tabIndex > visibleTabs.length - 1) setTabIndex(0);
  }, [visibleTabs.length, tabIndex]);

  if (visibleTabs.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>You do not have permission to view any user pages.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, width: "100%" }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Users Tabs"
        sx={{
          mb: 2,
          borderBottom: 1,
          borderColor: "divider",
          minHeight: 48,
        }}
      >
        {visibleTabs.map((tab, idx) => (
          <Tab key={idx} label={tab.label} sx={{ textTransform: "none" }} />
        ))}
      </Tabs>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        {visibleTabs[tabIndex]?.component}
      </Box>
    </Box>
  );
};

export default UsersPage;
